import { HTTP } from '@/http-common';
import { Dealer } from '../../../models/Dealer';

import { getField, updateField } from 'vuex-map-fields';
import { createHelpers } from 'vuex-map-fields';
import { httpError } from '@/models/httpError';

export const { mapFields: mapDealerFields } = createHelpers({
  getterType: `dealer/getField`,
  mutationType: `dealer/updateField`,
});

export const { mapMultiRowFields: mapDealerMultiRowFields } = createHelpers({
  getterType: 'dealer/getField',
  mutationType: 'dealer/updateField',
});

const state = () => ({
  dealer: new Dealer(),
  dealers: [],
  dealerTypes: [],
  message: new httpError(),
  dealerEmailAddressLog: [],
});

const actions = {
  resetDealer({ commit }) {
    commit('setDealer', new Dealer());
    commit('addDealers', [new Dealer()]);
  },
  sendLinkEmail({ dispatch, commit }, dealerID) {
    return new Promise(async (resolve, reject) => {
      try {
        var result = await HTTP.post(`DealerPortal/SendLinkEmail/${dealerID}`);
        if (result.status == 200) {
          dispatch(
            'setMessage',
            new httpError({ message: 'Email Sent', httpStatus: 200 })
          );
          resolve();
        }
      } catch (error) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'Sending Email Failed' + error.message,
            httpStatus: 500,
          })
        );
        reject();
      }
    });
  },
  refreshDealer({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get('oms/UpdateDealersFromOMS/')
        .then(() => {
          dispatch('listDealers');
          resolve();
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error in getting dealers : ' + err.message,
              httpStatus: 500,
            })
          );
          reject();
        });
    });
  },
  getDealer({ commit, dispatch }, dealerID) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get(
        'Order/getDealer/' + (dealerID || state.dealerID)
      );
      response
        .then(function(data) {
          var result = data.data;
          resolve(result);
          // if (dealerID) commit('setDealer', resultData);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error in getting dealers : ' + err.message,
              httpStatus: 500,
            })
          );
        });
    });
  },
  addDealer({ state, commit }) {
    commit('setDealer', state.dealer);
  },
  editDealerManager({ dispatch }, dealerManager) {
    return new Promise(async (resolve, reject) => {
      try {
        var result = await HTTP.post(
          'order/EditDealerManager/' + dealerManager.dealerId,
          dealerManager
        );
        if (result.status == 200) {
          dispatch(
            'setMessage',
            new httpError({ message: 'Dealer Edited', httpStatus: 200 })
          );
          resolve(
            typeof result.data == 'string' ? result.data : 'Details Saved!'
          );
        }
      } catch (error) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'Dealer Not Edited' + error.message,
            httpStatus: 500,
          })
        );
        reject(error);
      }
    });
  },
  async removeDealer({ commit, dispatch }, dealerID) {
    if (dealerID == null || typeof dealerID == 'undefined') {
      return new Promise.reject();
    }
    try {
      var result = await HTTP.delete('order/DeleteDealer/' + dealerID);
      if (result.status == 200) {
        commit('removeRow', dealerID);
        dispatch(
          'setMessage',
          new httpError({ message: 'Dealer removed', httpStatus: 200 })
        );
      }
    } catch (error) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Dealer not removed: ' + error.message,
          httpStatus: 500,
        })
      );
    }
  },
  listDealers({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('order/listDealers');
      response
        .then(data => {
          if (data.status !== 200) resolve();
          var result = data.data;
          commit('addDealers', result);
          dispatch(
            'setMessage',
            new httpError({ message: 'Dealers retrieved', httpStatus: 200 })
          );
          resolve(result);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error getting dealers' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  listDealersManagement() {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await HTTP.post('DealerPortal/ListDealersDetail');
        if (response.status !== 200) resolve(response);
        var result = response.data;
        resolve(result);
      } catch (err) {
        reject(err);
      }
    });
  },
  resetUserMFA({ dispatch }, email) {
    return new Promise((resolve, reject) => {
      HTTP.post(`Auth/ResetMFA/${email}`)
        .then(function(data) {
          if (data.status == 200) {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Multi-factor has been reset',
                httpStatus: 200,
              })
            );
            resolve(state.message);
          } else {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Invalid email!',
                httpStatus: 500,
              })
            );
            resolve(state.message);
          }
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Resetting:' + err.message,
              httpStatus: 500,
            })
          );
          reject(state.message);
        });
    });
  },
  paginadtedListDealersManagement({ dispatch }, query) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await HTTP.post(
          'DealerPortal/PaginatedListDealersDetail',
          query
        );
        if (response.status !== 200) resolve(response);
        var result = response.data;
        dispatch(
          'setMessage',
          new httpError({ message: 'Dealers retrieved', httpStatus: 200 })
        );
        resolve(result);
      } catch (err) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'Error getting dealers' + err,
            httpStatus: 500,
          })
        );
        reject(err);
      }
    });
  },
  getNewChannelPartnerLog({ dispatch }, query) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await HTTP.post(
          'DealerPortal/PaginatedListNewChannelPartnersLog',
          query
        );
        if (response.status !== 200) resolve(response);
        var result = response.data;
        dispatch(
          'setMessage',
          new httpError({ message: 'New Channel Partners Log retrieved', httpStatus: 200 })
        );
        resolve(result);
      } catch (err) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'Error getting data:' + err,
            httpStatus: 500,
          })
        );
        reject(err);
      }
    });
  },
  getDealerAuthList({ dispatch }, dealer) {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await HTTP.get('order/getDealerAuth/' + dealer.dealerID);
        dispatch(
          'setMessage',
          new httpError({ message: 'Retreived OK', httpStatus: 200 })
        );
        resolve(response.data);
      } catch (err) {
        reject(err);
      }
    });
  },
  revokeDealerPermission({ dispatch }, ubDealerId) {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await HTTP.delete(
          'order/DeleteDealerManager/' + ubDealerId
        );

        resolve(response.data);
      } catch (err) {
        reject(err);
      }
    });
  },
  getDealerManager({ dispatch }, dealerIndex) {
    return new Promise((resolve, reject) => {
      let response = HTTP.get('DealerPortal/GetDealerManager/' + dealerIndex);
      response
        .then(data => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Retreived OK', httpStatus: 200 })
          );
          resolve(data.data);
        })
        .catch(err => reject(err));
    });
  },
  updateDealerAuth({ dispatch }, auth) {
    return new Promise((resolve, reject) => {
      HTTP.post('dealerPortal/updateDealerAuth/', auth)
        .then(data => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Updated OK', httpStatus: 200 })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Not saved:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },

  updateDealerDetails({ dispatch }, dealer) {
    try {
      const res = HTTP.post('dealer/UpdateDealerDetails', {
        dealerManageDetail: dealer,
      });
      dispatch(
        'setMessage',
        new httpError({ message: 'Updated OK', httpStatus: 200 })
      );
    } catch (e) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Not saved:' + err.message,
          httpStatus: 500,
        })
      );
    }
  },

  updateDealerData({ dispatch }, dealerManager) {
    return new Promise((resolve, reject) => {
      let response = HTTP.post('dealerPortal/UpdateDealerData', dealerManager);
      response
        .then(data => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Updated OK', httpStatus: 200 })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Not saved:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },

  updateDealerManager({ dispatch }, dealerManager) {
    return new Promise((resolve, reject) => {
      let response = HTTP.post(
        'dealerPortal/updateDealerManager/0',
        dealerManager
      );
      response
        .then(data => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Updated OK', httpStatus: 200 })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Not saved:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  deleteDealerAuth({ dispatch }, authID) {
    return new Promise((resolve, reject) => {
      HTTP.delete('dealerPortal/deleteDealerAuth/' + authID)
        .then(data => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Updated OK', httpStatus: 200 })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Not saved:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  saveDealer({ dispatch }, dealer) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('order/updateDealer/' + dealer.dealerID, dealer);
      response
        .then(data => {
          var result = data.data;
          dispatch(
            'setMessage',
            new httpError({ message: 'Updated OK', httpStatus: 200 })
          );
          resolve(result);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Not saved:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  updateAuth({ dispatch }, auth) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('order/updateAuth', auth);
      response
        .then(data => {
          if (data.status == 200)
            dispatch(
              'setMessage',
              new httpError({
                message: 'Auth changed',
                httpStatus: 200,
              })
            );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Auth not saved:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  resetPassword({ dispatch }, email) {
    return new Promise((resolve, reject) => {
      HTTP.post('DealerPortal/resetAuth0Password', {
        email: email.trim(),
      })
        .then(function(data) {
          if (data.status == 200) {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Reset email submitted',
                httpStatus: 200,
              })
            );
            resolve(state.message);
          } else {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Email missing!',
                httpStatus: 500,
              })
            );
            resolve(state.message);
          }
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Reset email Not sent:' + err.message,
              httpStatus: 500,
            })
          );
          reject(state.message);
        });
    });
  },

  async getAuth({ dispatch, commit }, email) {
    return new Promise(async (resolve, reject) => {
      if (typeof email == 'undefined') {
        resolve();
        return;
      }

      try {
        var response = await HTTP.post('Order/getDealerFromEmail', {
          email: email,
        });
        var resultData = response.data;

        //commit("setDealer", response.data);
        resolve(resultData);
      } catch (error) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'unable to retrieve auth level',
            httpStatus: 500,
          })
        );
        reject(error);
      }
    });
  },
  searchAuth0({ state, dispatch }, email) {
    return new Promise((resolve, reject) => {
      HTTP.post('DealerPortal/searchAuth0User', {
        email: email.trim(),
      })
        .then(data => {
          if (data.status == 200) {
            dispatch(
              'setMessage',
              new httpError({
                message: 'SOG email validated',
                httpStatus: 200,
              })
            );
            resolve(state.message);
          } else {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Email missing!',
                httpStatus: 500,
              })
            );
            resolve(state.message);
          }
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err.message,
              httpStatus: 500,
            })
          );
          reject(state.message);
        });
    });
  },

  async addNewUser({ dispatch, commit }, payload) {
    let isCreated = false;

    try {
      let isExisting = await HTTP.post('DealerPortal/searchAuth0User', {
        email: payload.customerEmail,
      });

      if (isExisting.status === 204) {
        await HTTP.post('DealerPortal/createAuthUser', {
          email: payload.customerEmail,
        });
      }

      let authLevel =
        payload.authGroupName === 'Administrators'
          ? 'Admin'
          : payload.authGroupName;

      let dealer = {
        DealerID: payload.dealerID,
        DealerFullName: payload.customerName,
        DealerEmail: payload.customerEmail,
        AuthLevel: authLevel,
        AuthGroup: payload.authGroupName,
      };

      let dealerData = await HTTP.post(
        `DealerPortal/saveNewLogin/${payload.applicationID}`,
        dealer
      );

      if (dealerData.status === 200) {
        isCreated = true;
        dispatch(
          'setMessage',
          new httpError({
            message: 'User added successfully!',
            httpStatus: 200,
          })
        );
      } else {
        isCreated = false;
        dispatch(
          'setMessage',
          new httpError({
            message: 'Adding user failed!',
            httpStatus: 500,
          })
        );
      }

      return Promise.resolve(isCreated);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  createAuth({ dispatch }, email) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('DealerPortal/createAuthUser', {
        email: email.trim(),
      });
      response
        .then(data => {
          if (data.status == 200) {
            dispatch(
              'setMessage',
              new httpError({
                message: 'SOG email created',
                httpStatus: 200,
              })
            );
          } else
            dispatch(
              'setMessage',
              new httpError({
                message: 'Email missing!',
                httpStatus: 500,
              })
            );
          resolve();
        })
        .catch(err => {
          const is_validation_error = err.response.data.message.includes(
            'validation'
          );
          dispatch(
            'setMessage',
            new httpError({
              // message: "Error: " + err.message,
              message: is_validation_error
                ? 'Email does not pass Auth0`s email format validation'
                : 'The user already exists.',
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  getContract({ dispatch }, dealerID) {
    return new Promise(async reject => {
      try {
        var response = await HTTP.get(
          'DealerPortal/DownloadDealerContract/' + dealerID,
          { responseType: 'blob' }
        );

        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: response.type })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'contract_' + dealerID + '.pdf');
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        dispatch(
          'setMessage',
          new httpError({
            message:
              'Contract not found/Dealer has not signed the contract yet.',
            httpStatus: 500,
          })
        );
        reject(err);
      }
    });
  },
  getDealerContract({ dispatch }, payload) {
    return new Promise(async reject => {
      try {
        var response = await HTTP.get(
          `DealerPortal/DownloadDealerContract/${payload.dealerID}/${payload.file}`,
          { responseType: 'blob' }
        );

        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: response.data.type })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', payload.file);
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        dispatch(
          'setMessage',
          new httpError({
            message:
              'Contract not found/Dealer has not signed the contract yet.',
            httpStatus: 500,
          })
        );
        reject(err);
      }
    });
  },
  getContractList({ dispatch }, dealerID) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('DealerPortal/GetDealerContracts/' + dealerID);
      response
        .then(data => {
          if (data.status == 200) {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Contract list retrieved.',
                httpStatus: 200,
              })
            );
          } else
            dispatch(
              'setMessage',
              new httpError({
                message: 'Failed to retrieve contract list.',
                httpStatus: 500,
              })
            );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              // message: "Error: " + err.message,
              message: 'Failed to retrieve contract list.',
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  uploadContract({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        'DealerPortal/UploadDealerContract/' + payload.dealerID,
        payload.file,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      response
        .then(data => {
          if (data.status == 200) {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Contract uploaded successfully.',
                httpStatus: 200,
              })
            );
          } else
            dispatch(
              'setMessage',
              new httpError({
                message: 'Failed to upload contract.',
                httpStatus: 500,
              })
            );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              // message: "Error: " + err.message,
              message: 'Failed to upload contract.',
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  listMissingDealers() {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await HTTP.post('DealerPortal/MissingDealers');
        if (response.status !== 200) resolve(response);
        var result = response.data;
        resolve(result);
      } catch (err) {
        reject(err);
      }
    });
  },
  getDealerTypes({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await HTTP.get('Order/getDealerTypes');
        if (response.status !== 200) reject(response);
        var result = response.data;
        commit('setDealerTypes', result);
        resolve(result);
      } catch (err) {
        reject(err);
      }
    });
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },

  deactivateUser({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      HTTP.post(`DealerPortal/DeactivateUser/${id}`)
        .then(function(data) {
          if (data.status == 200) {
            dispatch(
              'setMessage',
              new httpError({
                message: 'User has been deactivated',
                httpStatus: 200,
              })
            );
            resolve(state.message);
          } else {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Invalid email!',
                httpStatus: 500,
              })
            );
            resolve(state.message);
          }
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Deactivation:' + err.message,
              httpStatus: 500,
            })
          );
          reject(state.message);
        });
    });
  },
  getDealerEmailAddressLog({ dispatch }, dealerID) {
    return new Promise((resolve, reject) => {
      HTTP.get(`DealerPortal/GetDealerEmailAddressLog/${dealerID}`)
        .then(function(data) {
          if (data.status == 200) {
            resolve(data.data);
          } else {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Failed to get dealer email address log.',
                httpStatus: 500,
              })
            );
            resolve(state.message);
          }
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Failed to get dealer email address log:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  recordDealerEmailChange({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      HTTP.post('DealerPortal/RecordDealerEmailChange', payload)  
        .then(function(data) {
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Failed to udpate dealer email:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  checkDealerEmailAddressExist({ dispatch }, { ubDealerID, email }) {
    return new Promise((resolve, reject) => {
      HTTP.get('DealerPortal/HasEmailBeenLoggedForDealer', {
        params: { ubDealerID, email },
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          const status = err.response && err.response.status;
          dispatch(
            'setMessage',
            new httpError({
              message: 'Failed to check dealer email address:' + err.message,
              httpStatus: status || 500,
            })
          );
          reject(err);
        });
    });
  },
};

const mutations = {
  setDealer(state, dealer) {
    state.dealer = dealer;
  },
  setProgress(state, message) {
    state.message = message;
  },
  addDealers(state, dealers) {
    state.dealers = dealers;
  },
  addRow(state) {
    let dealer = new Dealer();
    state.dealers.push(dealer);
    return state.dealers.indexOf(dealer);
  },
  removeRow(state, dealerID) {
    let dealer = state.dealers.filter(x => x.dealerID == dealerID);
    let index = state.dealers.indexOf(dealer[0]);
    if (index > 0) state.dealers.splice(index, 1);
  },
  setDealerTypes(state, dealerTypes) {
    state.dealerTypes = dealerTypes;
  },
  updateField,
};
const getters = {
  dealer: state => {
    return state.dealer;
  },
  hasDealer: state => state.dealer.dealerID > 0,
  dealerTypes: state => state.dealerTypes,
  dealerEmailAddressLog: state => state.dealerEmailAddressLog,
  getField,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
